import { type ReactElement, type ReactNode } from "react"
import ForgotPasswordForm from "src/features/authentication/components/ForgotPasswordForm";
import dsxImage from '../assests/images/dsx.png';

export interface ForgotPaswordProps {
	children?: ReactNode
}

export function ForgotPasswordPage(props: ForgotPaswordProps): ReactElement {
	return <>
		<div className="font-[sans-serif]">
			<div className="grid lg:grid-cols-3 md:grid-cols-2 items-center gap-4">
				<div className="max-md:order-1 lg:col-span-2 md:h-screen w-full bg-[#000842] md:rounded-tr-xl md:rounded-br-xl lg:p-12 p-8">
					<img src={dsxImage} className="lg:w-[60%] w-full object-contain block mx-auto" alt="login-image" />
				</div>

				<ForgotPasswordForm />

			</div>
		</div>
	</>
}
